export default __webpack_public_path__ + "static/media/BrutalType-Regular.b0478d72.svg";